import { InlineErrorProps } from '../../types/components/shared/InlineError';

const InlineError: React.FC<InlineErrorProps> = (props: InlineErrorProps) => {
  const { errorMessage } = props;
  if (!errorMessage) return <></>;
  return <p className="bg-red-900 text-white p-3 text-[12px]" cy-test-id="error-message">{errorMessage}</p>
}

export default InlineError;
